import { useRef } from 'react';
import { UserPlus, Calendar, MonitorSmartphone, Activity, type LucideIcon } from 'lucide-react';
import { useLang } from '../../../i18n';
import useIntersectionFadeIn from '../../../hooks/useIntersectionFadeIn';

interface Step { num: string; icon: LucideIcon; title: string; desc: string }

export default function ProcessSection() {
  const { t } = useLang();
  const rootRef = useRef<HTMLElement>(null);
  const visible = useIntersectionFadeIn(rootRef);

  const steps: Step[] = [
    { num: '01', icon: UserPlus, title: t('home.process.step1.t'), desc: t('home.process.step1.d') },
    { num: '02', icon: Calendar, title: t('home.process.step2.t'), desc: t('home.process.step2.d') },
    { num: '03', icon: MonitorSmartphone, title: t('home.process.step3.t'), desc: t('home.process.step3.d') },
    { num: '04', icon: Activity, title: t('home.process.step4.t'), desc: t('home.process.step4.d') },
  ];

  return (
    <section ref={rootRef} className={`section section--dark process scroll-fade-in${visible ? ' scroll-fade-in--visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <span className="eyebrow process__eyebrow">{t('home.process.eyebrow')}</span>
          <h2>{t('home.process.title')}</h2>
          <p className="lead process__lead">{t('home.process.sub')}</p>
        </header>

        <ol className="process__list">
          {steps.map((s, idx) => {
            const Icon = s.icon;
            const isLast = idx === steps.length - 1;
            return (
              <li key={s.num} className="process__step">
                <div className="process__step-head">
                  <span className="process__step-icon" aria-hidden="true">
                    <Icon size={22} strokeWidth={1.75} />
                  </span>
                  <span className="process__step-num">STEP / {s.num}</span>
                </div>
                <h3 className="process__step-title">{s.title}</h3>
                <p className="process__step-desc">{s.desc}</p>
                {!isLast ? (
                  <span className="process__dots" aria-hidden="true">• • •</span>
                ) : null}
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
